import { useQueryClient } from 'react-query'

export const useInvalidateGetValueMessageLinkedDataQuery = () => {
    const queryClient = useQueryClient()

    const invalidateGetValueMessageLinkedDataQuery = async () => {
        await queryClient.invalidateQueries('valueMessageLinkedData')
    }

    return { invalidateGetValueMessageLinkedDataQuery }
}
